const d3 = require('d3');

import {gVars} from './00-global-init.js';

export function round(number, precision) {
  var numArray, precision;

  var shift = function (number, precision, reverseShift) {
    if (reverseShift) {
      precision = -precision;
    }
    numArray = ("" + number).split("e");
    return +(numArray[0] + "e" + (numArray[1] ? (+numArray[1] + precision) : precision));
  };

  return shift(Math.round(shift(number, precision, false)), precision, true);
}

// Get voting age population
export function cd27HispanicPercent(text) {
  var year = parseInt(text),
    hispanic_pop,
    total_pop;

  // TX Leg Council
  if (year === 2010) {
    hispanic_pop = 363131;
    total_pop = 524686;
  } if (year === 2012) {
    hispanic_pop = 233071;
    total_pop = 516473;
  }

  return round(hispanic_pop / total_pop * 100, 0);
}

export function setOverlayColors(input, overlay) {
  var percents, num;

  if (overlay == 'hispanic') {
    percents = [20, 40, 60, 80, 100];
  } else {
    percents = [50, 70, 100];
  }

  if (input == 'percents') {
    return percents;
  } else {
    if (overlay == 'hispanic') {
      num = parseInt(input);

      if (num == 0) {
        return '#FFF';
      } else if (num <= percents[0]) {
        return '#E5DDEE';
      } else if (num <= percents[1]) {
        return '#CBB9E0';
      } else if (num <= percents[2]) {
        return '#B196D3';
      } else if (num <= percents[3]) {
        return '#9772C5';
      } else if (num <= percents[4]) {
        return '#7D4EB7';
      }
    } else if (overlay == 'vtds') {
      var party_won = '';
      num = 0;

      // Rep won precinct
      if ( parseInt(input[0]) > parseInt(input[1]) ) {
        party_won = 'rep';
        num = parseInt(input[2]);
      // Dem won precinct
      } else if ( parseInt(input[0]) < parseInt(input[1]) ) {
        party_won = 'dem';
        num = parseInt(input[3]);
      } else {
        party_won = 'tie';
      }

      if (party_won == 'rep') {
        if (num == 0) {
          return '#FFF';
        } else if (num <= percents[0]) {
          return '#F9BBBB';
        } else if (num <= percents[1]) {
          return '#E88281';
        } else if (num <= percents[2]) {
          return '#D74947';
        }
      } else if (party_won == 'dem') {
        if (num == 0) {
          return '#FFF';
        } else if (num <= percents[0]) {
          return '#B8D5E1';
        } else if (num <= percents[1]) {
          return '#68A5C9';
        } else if (num <= percents[2]) {
          return '#1775B0';
        }
      } else {
        return '#FFF';
      }
    }
  }
}

// Is this district a hispanic opportunity district?
export function isHOD(c_year, c_district = null) {
  var hods;

  if (c_year <= 2010 && c_year >= 2002) {
    hods = [16, 23, 20, 28, 27, 15, 16, 29];
  } else if (c_year >= 2012) {
    hods = [16, 23, 20, 28, 15, 29, 34, 35];
  }

  // If we have a district parameter
  // We'll return whether or not this district is an HOD
  if (c_district) {
    if (hods.indexOf(c_district) > -1) {
      return true;
    } else {
      return false;
    }
  // Otherwise we'll return the number of HODs for this year
  } else {
    return hods.length;
  }
// close is hod
}

export function setYearText(year) {
  var winner, party, win_perc, first_name;

  if (year <= 2008) {
    first_name = 'Solomon';
    winner = 'Ortiz';
    party = 'dem';
  } else {
    first_name = 'Blake';
    winner = 'Farenthold';
    party = 'rep';
  }

  if (year == 1982) {
    win_perc = '64%';
  } else if (year == 1984) {
    win_perc = '64%';
  } else if (year == 1986) {
    win_perc = 'Uncontested';
  } else if (year == 1988) {
    win_perc = 'Uncontested';
  } else if (year == 1990) {
    win_perc = 'Uncontested';
  } else if (year == 1992) {
    win_perc = '56%';
  } else if (year == 1994) {
    win_perc = '59%';
  } else if (year == 1996) {
    win_perc = '65%';
  } else if (year == 1998) {
    win_perc = '63%';
  } else if (year == 2000) {
    win_perc = '63%';
  } else if (year == 2002) {
    win_perc = '61%';
  } else if (year == 2004) {
    win_perc = '63%';
  } else if (year == 2006) {
    win_perc = '57%';
  } else if (year == 2008) {
    win_perc = '58%';
  } else if (year == 2010) {
    win_perc = '48%';
  } else if (year == 2012) {
    win_perc = '57%';
  } else if (year == 2014) {
    win_perc = '64%';
  } else if (year == 2016) {
    win_perc = '62%';
  }

  return [winner, party, win_perc, first_name];
}

export function svgElements(c_year, wrapper_id, iter_array) {
  var map_class = null,
    width = null,
    height = null,
    circle_radius_minus = null,
    all_texas = null,
    all_texas_class = '',
    clipped_g;

  if (wrapper_id == gVars.map_key) {
    map_class = 'key-map';
    width = gVars.width_key_map;
    height = gVars.height_key_map;
    circle_radius_minus = 8;
    all_texas = true;
  } else if (wrapper_id == gVars.map_vtds || wrapper_id == gVars.map_farenthold_home) {
    map_class = 'three';
    width = gVars.width_three;
    height = gVars.height_three;
    circle_radius_minus = 18;
    all_texas = false;
  } else if (wrapper_id == gVars.map_mini) {
    map_class = 'mini';
    width = gVars.width_mini;
    height = gVars.height_mini;
    circle_radius_minus = 8;
    all_texas = false;
  } else if (wrapper_id == gVars.map_redistricting) {
    map_class = 'four';
    width = gVars.width_four;
    height = gVars.height_four;
    circle_radius_minus = 18;
    all_texas = false;
  } else if (wrapper_id == gVars.map_hod) {
    map_class = 'two';
    width = gVars.width_all_texas;
    height = gVars.height_all_texas;
    circle_radius_minus = 18;
    all_texas = true;
  } else {
    map_class = 'two';
    width = gVars.width_two;
    height = gVars.height_two;
    circle_radius_minus = 18;
    all_texas = false;
  }

  if (window.innerWidth < gVars.mobile_width) {
    width = gVars.width_mini;
    height = gVars.height_mini;
    circle_radius_minus = 8;
  }

  if (all_texas) {
    all_texas_class = 'map-container-all-tx';
  }

  var year_text = setYearText(c_year);

  // All the things that make up our beautiful maps
  var wrapper_maps_key = d3.select(wrapper_id + '-key-wrapper')
    .attr('class', 'maps-' + map_class + '-key-wrapper');

  var wrapper_parent = d3.select(wrapper_id);
  var wrapper = wrapper_parent.select('#maps-' + wrapper_id.replace('#',''));
  var container = wrapper.append('div')
    .attr("class", "map-" + c_year + "-container " + " map-"  + map_class + "-container " + all_texas_class + " map-container");

  if (wrapper_id != gVars.map_key) {
    var text = container.append('div')
      .attr("class", "map-header")
      .html(c_year);
  }

  var w_name;
  if (!all_texas) {
    var pill = '',
      bar = '';

    pill += '<span class="pill circle-pill pill--' + year_text[1] + '">';
    pill += year_text[1].substring(0,1).toUpperCase();
    pill += '</span>';

    if (year_text[2] != 'Uncontested') {
      bar += '<div class="bar-container">';
      bar += '<div class="bar ' + year_text[1] + '-color-background" style="width: ' + year_text[2] + '">';
      bar += '</div>';
      bar += '</div>';
    }

    w_name = '<table class="table-name-perc">';
    w_name += '<tr>';
    w_name += '<td class="name ' + year_text[1] + '-color-dark">';
    if (c_year == 1982 && year_text[0] == 'Ortiz' && wrapper_id == gVars.map_mini || c_year == 2008 && year_text[0] == 'Ortiz' && wrapper_id == gVars.map_vtds || c_year == 2010 && year_text[0] == 'Farenthold' && wrapper_id == gVars.map_vtds) {
      w_name += '<div class="name-text">' + year_text[3] + ' ' + year_text[0] + ': ' + '</div>';
    } else {
      w_name += '<div class="name-text">' + year_text[0] + ': ' + '</div>';
    }
    w_name += '</td>';
    w_name += '<td class="perc-bar">';
    w_name += '<div class="perc">' + year_text[2] + '</div>';
    // w_name += bar;
    w_name += '</td>';
    w_name += '</tr>';
    w_name += '</table>';
  }

  if (!all_texas) {
    var w_header = container.append('div')
      .attr("class", "winner-header " + "winner-header-" + year_text[1])
      .html(w_name);
  }

  var svg = container.append("svg")
    .attr('width', width)
    .attr('height', height - 5);

  if (!all_texas) {
    var clip_path, clip_circle;
    if (gVars.maps_shapes == 'circle') {
      clip_path = svg.append('defs')
        .append("clipPath")
        .attr('id', 'cut-out-circle-' + wrapper_id.replace('#','') )
        .append("circle")
        .attr("cx", (width / 2) )
        .attr("cy", (height / 2) )
        .attr("r", (width / 2) - circle_radius_minus );

      clip_circle = svg.append("circle")
        .attr('class', 'circle-telescope-container')
        .attr("x", 5)
        .attr("cx", (width / 2) )
        .attr("cy", (height / 2) )
        .attr("r", (width / 2) - (circle_radius_minus - 1) );
    } else if (gVars.maps_shapes == 'rect') {
      clip_path = svg.append('defs')
        .append("clipPath")
        .attr('id', 'cut-out-circle-' + wrapper_id.replace('#','') )
        .append("rect")
        .attr("width", width)
        .attr("height", height - 10);

      clip_circle = svg.append("rect")
        .attr('class', 'circle-telescope-container')
        .attr("width", width - 10)
        .attr("height", height - 10);
    }

    clipped_g = svg.append('g')
      .attr('class', 'clipped-g')
      .attr("clip-path","url(#cut-out-circle-" + wrapper_id.replace('#','') + ")");

    var mexico = clipped_g.append('g')
      .attr("class","land");
  } else {
    clipped_g = svg.append('g')
      .attr('class', 'clipped-g');
  }

  var overlay = clipped_g.append('g')
    .attr("class","overlay");

  var districts = clipped_g.append('g')
    .attr("class","districts");

  var counties = clipped_g.append('g')
    .attr("class","counties");

  var annotations = clipped_g.append('g')
    .attr("class","annotations-g");

  if (wrapper_id == gVars.map_key) {
    var locator_circle = clipped_g.append('g')
      .attr("class","locator-circle");
  }
  // Overlay key only for container that has overlays
  // And only append after final map iteration has been rendered
  var maps_key_wrapper = d3.select(wrapper_id + '-key-wrapper');
  var top_maps_key_wrapper =  maps_key_wrapper.select('.top-copy-key-container');
  var bottom_maps_key_wrapper =  maps_key_wrapper.select('.bottom-copy-key-container'),
    overlay_key;

  if (gVars.overlay_maps.includes(wrapper_id) && iter_array[0] == iter_array[1]) {
    overlay_key = bottom_maps_key_wrapper.insert("div",":first-child")
      .attr("class", "overlay-key");
  } else if (gVars.overlay_map_vtds.includes(wrapper_id) && iter_array[0] == iter_array[1]) {
    overlay_key = bottom_maps_key_wrapper.insert("div",":first-child")
      .attr("class", "overlay-key");
  }

  if (gVars.hod_maps.includes(wrapper_id) && iter_array[0] == iter_array[1]) {
    var hod_div = bottom_maps_key_wrapper.insert("div",":first-child")
      .attr('class', 'key-wrapper');
    var new_div;

    new_div = hod_div.append('div')
      .attr("class", "hod-wrapper");
    new_div.append('span')
      .attr("class", "key");
    new_div.append('span')
    .attr("class", "text")
      .html('Hispanic opportunity districts');

    if (wrapper_id == gVars.map_hod_zoom) {
      new_div = hod_div.append('div')
        .attr("class", "cd-27-wrapper cd-wrapper");
      new_div.append('span')
        .attr("class", "key");
      new_div.append('span')
        .attr("class", "text")
        .html('Congressional District 27');

      new_div = hod_div.append('div')
        .attr("class", "cd-extra-wrapper cd-wrapper");
      new_div.append('span')
        .attr("class", "key");
      new_div.append('span')
        .attr("class", "text")
        .html('Congressional District 34 (created in 2011)');
    }
  }

  return [
    svg, counties, districts, wrapper_id, map_class, mexico, all_texas, overlay
  ];
}

export function setYear(year) {
  var c_year_fp = '';
  var c_year_fp_prop = '';

  if (year == 1982) {
    c_year_fp = '1982/Congress_82';
    c_year_fp_prop = 'STR_1982_1';
  } else if (year <= 1990) {
    c_year_fp = '1984-90/Congress_84_90';
    c_year_fp_prop = 'STR_1984_1';
  } else if (year <= 1994) {
    c_year_fp = '1992-96/Congress_92_96P';
    c_year_fp_prop = 'DISTRICT';
  } else if (year <= 2000) {
    c_year_fp = '1996-2000/PlanC0746_96_00_Elections';
    c_year_fp_prop = 'DISTRICT';
  } else if (year <= 2002) {
    c_year_fp = '2002-election/PlanC1151_02_Election';
    c_year_fp_prop = 'DISTRICT';
  } else if (year <= 2004) {
    c_year_fp = '2004-election/PlanC1374_04_Election';
    c_year_fp_prop = 'DISTRICT';
  } else if (year <= 2010) {
    c_year_fp = '2006-election/PlanC1440_06_10_Elections';
    c_year_fp_prop = 'DISTRICT';
  } else if (year >= 2012) {
    c_year_fp = '2012-current/PLANC235';
    c_year_fp_prop = 'District';
  }

  return [c_year_fp, c_year_fp_prop];
}

export function addBarElements() {
  var years_dem = gVars.years_dem;
  var years_rep = gVars.years_rep;
  var all_years = years_dem.concat(years_rep).sort();
  var bar_wrapper_mini = d3.select('#bar-wrapper-mini');
  var bar_html = '';

  for (var x = 0; x < all_years.length; x++) {
    var c_year = all_years[x],
      party = '';
    if ( years_dem.includes(c_year) ) {
      party = 'dem';
    } else if ( years_rep.includes(c_year) ) {
      party = 'rep';
    }

    bar_html += '<div id="bar-' + c_year + '" class="bar ' + party + '-color-background">';
    bar_html += '<div class="bar-year">' + c_year + '</div>';
    bar_html += '</div>';
  }

  bar_wrapper_mini.html(bar_html);
}

// Sets zoom, placement of map based on wrapper
export function fitExtentParams(wrapper_id, map_class, all_texas, overlay, zoom_hod) {
  var params;

  if (all_texas == true) {
    if (map_class == 'mini') {
      params = [
        [20, 20],
        [(gVars.width_mini - 20), (gVars.height_mini - 20)]
      ];
    } else if (map_class == 'key-map') {
      params = [
        [20, 20],
        [(gVars.width_key_map - 20), (gVars.height_key_map - 20)]
      ];
    } else if (window.innerWidth < gVars.mobile_width) {
      params = [
        [5, 5],
        [(gVars.width_mini - 5), (gVars.height_mini - 5)]
      ];
    } else {
      params = [
        [20, 20],
        [(gVars.width_two - 20), (gVars.height_two - 20)]
      ];
    }
  } else if (zoom_hod != null) {
    if (window.innerWidth < gVars.mobile_width) {
      params = [
        [-200, -250],
        [gVars.width_mini, gVars.height_mini]
      ];
    } else if (map_class == 'two') {
      params = [
        [-250, -350],
        [gVars.width_two, gVars.height_two]
      ];
    }
  } else if (map_class == 'mini' || window.innerWidth < gVars.mobile_width) {
    params = [
      [-230, -255],
      [gVars.width_mini, gVars.height_mini]
    ];
  } else if (map_class == 'two') {
    params = [
      [-375, -375],
      [(gVars.width_two * 0.9), (gVars.height_two * 0.9)]
    ];
  } else if (map_class == 'three') {
    params = [
      [-350, -375],
      [gVars.width_three, gVars.height_three]
    ];
  } else if (map_class == 'four') {
    params = [
      [-250, -275],
      [(gVars.width_four * 0.9), (gVars.height_four * 0.95)]
    ];
  }

  return params;
}



// WEBPACK FOOTER //
// ./00-global-functions.js